// extracted by mini-css-extract-plugin
export default {"cls1":"j1WyUK0n1AYIO7lQfKLH","cls2":"sxUR49dK1sParBgiyR21 j1WyUK0n1AYIO7lQfKLH"};